import { createRouter, Navigate } from '@tanstack/react-router';

import { MainLoader, PageError } from './_components';
import { queryClient } from './_shared/utils/query-client';
import { routeTree } from './routeTree.gen';

export const tsRouter = createRouter({
  routeTree,
  defaultPendingComponent: MainLoader,
  defaultErrorComponent: PageError,
  defaultNotFoundComponent: () => <Navigate to="/" />,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadDelay: 300,
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  defaultPendingMs: 100,
});
